import { useMoment } from '@/shared/composition/useMoment';
import { Date } from '@/app/modules/date/Date';
import { registerApplier } from '@/app/libs/I';
import { dateService } from '@/app/modules/date/DateService';

registerApplier(dateService.applierId, (date: Date) => {
  const moment = useMoment();
  return date.takeChanged({
    formattedValue: moment(date.value).format(date.format),
  });
});
